import type React from 'react';
import { BaseChart, Card } from 'components';
import type Highcharts from 'highcharts';

// Replace dummy data once real data is implemented
const DUMMY_DATA = [
  {
    name: 'Reseller 1',
    count: 30,
  },
  {
    name: 'Reseller 2',
    count: 13,
  },
  {
    name: 'Reseller 3',
    count: 7,
  },
  {
    name: 'Reseller 4',
    count: 3,
  },
  {
    name: 'Others',
    count: 20,
  },
];

export interface IncomeChartProps {
  data?: {
    name: string;
    count: number;
  }[];
}

const getChartOptions = (): Highcharts.Options => ({
  colors: ['#1BA39C', '#92DB36', '#29BFE5', '#F2DB09', '#F0F2F5'],
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    height: 275,
  },
  tooltip: {
    formatter() {
      return `<b>${this.key}:</b> ${this.y?.toString()} (${this.percentage.toFixed(2)}%)`;
    },
  },
  title: {
    text: 'Dummy income',
    align: 'left',
    style: { fontSize: '20px', fontWeight: 'bold' },
    x: -10,
  },
  series: [
    {
      type: 'pie',
      data: DUMMY_DATA.map(item => ({
        name: item.name ?? 'Unknown',
        y: item.count,
      })),
      innerSize: '70%',
    },
  ],
});

export const IncomeChart: React.VFC<IncomeChartProps> = () => {
  const options = getChartOptions();

  return (
    <Card $sameHeight>
      <BaseChart options={options} />
    </Card>
  );
};
